"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCostSeries = exports.sumRangeKwh = exports.hourKeysOf = exports.datesInRange = exports.OTHER_ROW_KEY = void 0;
/** Row key for "Other": mains energy no branch CT or HVAC system accounts for. */
exports.OTHER_ROW_KEY = 'other';
const pad = (n) => String(n).padStart(2, '0');
/** Every `YYYY-MM-DD` from start to end, inclusive. */
const datesInRange = (startDate, endDate) => {
    const [year, month, day] = startDate.split('-').map(Number);
    const cursor = new Date(year, month - 1, day);
    const dates = [];
    for (;;) {
        const date = `${cursor.getFullYear()}-${pad(cursor.getMonth() + 1)}-${pad(cursor.getDate())}`;
        if (date > endDate)
            return dates;
        dates.push(date);
        cursor.setDate(cursor.getDate() + 1);
    }
};
exports.datesInRange = datesInRange;
/** The 24 `YYYY-MM-DD-HH` hour keys of a day — the rollup `dateHour` format. */
const hourKeysOf = (date) => Array.from({ length: 24 }, (_, hour) => `${date}-${pad(hour)}`);
exports.hourKeysOf = hourKeysOf;
/**
 * Mains and per-row kWh summed over an inclusive date range. With `endDateHours`, the end
 * date counts only its first N hours (from the hourly maps) — how a period still in progress
 * is compared over the SAME stretch of an earlier one ("today until 1 PM vs last Tuesday
 * until 1 PM"), instead of a partial day against a whole one.
 */
const sumRangeKwh = (daily, hourly, startDate, endDate, endDateHours) => {
    const cutDate = endDateHours === undefined ? null : endDate;
    let mainsKwh = 0;
    const kwhByKey = new Map();
    const addRows = (rows) => rows?.forEach((kwh, key) => kwhByKey.set(key, (kwhByKey.get(key) ?? 0) + kwh));
    // YYYY-MM-DD compares correctly as strings; iterate only dates that have data.
    daily.mains.forEach((kwh, date) => {
        if (date >= startDate && date <= endDate && date !== cutDate)
            mainsKwh += kwh;
    });
    daily.rows.forEach((rows, date) => {
        if (date >= startDate && date <= endDate && date !== cutDate)
            addRows(rows);
    });
    if (cutDate) {
        (0, exports.hourKeysOf)(cutDate)
            .slice(0, endDateHours)
            .forEach((key) => {
            mainsKwh += hourly.mains.get(key) ?? 0;
            addRows(hourly.rows.get(key));
        });
    }
    return { mainsKwh, kwhByKey };
};
exports.sumRangeKwh = sumRangeKwh;
/**
 * One point per bucket key. No `rowKey` = whole-panel (mains) energy; `OTHER_ROW_KEY` =
 * mains minus every attributed row in that bucket (never below 0 — branch CTs can slightly
 * over-read the mains); anything else = that row's energy. Missing buckets read 0.
 */
const buildCostSeries = (keys, mainsByKey, rowsByKey, ratePerKwh, rowKey) => keys.map((key) => {
    const mains = mainsByKey.get(key) ?? 0;
    const rows = rowsByKey.get(key);
    let kwh;
    if (!rowKey) {
        kwh = mains;
    }
    else if (rowKey === exports.OTHER_ROW_KEY) {
        let attributed = 0;
        rows?.forEach((value) => {
            attributed += value;
        });
        kwh = Math.max(0, mains - attributed);
    }
    else {
        kwh = rows?.get(rowKey) ?? 0;
    }
    return { key, kwh, cost: kwh * ratePerKwh };
});
exports.buildCostSeries = buildCostSeries;
